import React from 'react';

type IconElement = (iconProps: IconProps) => JSX.Element;

type IconProps = {
  fill?: string;
};

type NavigationIconProps = {
  color?: string;
  Icon: IconElement;
};

const NavigationIcon = ({ color, Icon }: NavigationIconProps): JSX.Element => {
  return <Icon fill={color} />;
}

NavigationIcon.defaultProps = {
  color: '#FFFFFF',
};

export default NavigationIcon;
